var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4 37L20.85 24.45L23.7 21.6L36.25 34.15L33.4 37ZM4.35 37L1.5 34.15L16 19.65L10.65 14.3L9.5 15.45L7.3 13.25V17.5L6.1 18.7L0 12.6L1.2 11.4H5.5L3.1 9L9.65 2.45C10.2167 1.88333 10.8333 1.5 11.5 1.3C12.1667 1.1 12.9 0.999997 13.7 0.999997C14.5 0.999997 15.2333 1.14166 15.9 1.425C16.5667 1.70833 17.1833 2.13333 17.75 2.7L12.4 8.05L14.8 10.45L13.6 11.65L18.8 16.85L24.9 10.75C24.6333 10.3167 24.425 9.81666 24.275 9.25C24.125 8.68333 24.05 8.08333 24.05 7.45C24.05 5.68333 24.6917 4.15833 25.975 2.875C27.2583 1.59166 28.7833 0.949997 30.55 0.949997C31.05 0.949997 31.475 0.999997 31.825 1.1C32.175 1.2 32.4667 1.33333 32.7 1.5L28.45 5.75L32.2 9.5L36.45 5.25C36.6167 5.51666 36.7583 5.84166 36.875 6.225C36.9917 6.60833 37.05 7.05 37.05 7.55C37.05 9.31666 36.4083 10.8417 35.125 12.125C33.8417 13.4083 32.3167 14.05 30.55 14.05C29.95 14.05 29.4333 14.0083 29 13.925C28.5667 13.8417 28.1667 13.7167 27.8 13.55L4.35 37Z",
    fill: "#BA4E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.589932454f57ff2ec93fcaf42bd10813.svg";
export { ForwardRef as ReactComponent };